"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTrainingCard = void 0;
const styles_1 = require("@mui/material/styles");
const training_card_1 = __importDefault(require("../training-card"));
const styles_2 = require("../tappable-card/styles");
exports.StyledTrainingCard = (0, styles_1.styled)(training_card_1.default)(({ theme }) => ({
    [`.${styles_2.classes.subtitle}`]: {
        color: theme.colours.charcoal
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RyYWluaW5nLWNhdGFsb2d1ZS1jYXJkL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBOEM7QUFDOUMscUVBQTRDO0FBQzVDLG9EQUFrRDtBQUVyQyxRQUFBLGtCQUFrQixHQUFHLElBQUEsZUFBTSxFQUFDLHVCQUFZLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDckUsQ0FBQyxJQUFJLGdCQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsRUFBRTtRQUN4QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRO0tBQzlCO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==